const WORDS = ["Roofing", "Commercial Builds", "Remodels", "Metal Roofs", "Additions", "TPO Systems"];

export const Marquee = () => {
  const row = WORDS.map((w) => (
    <span key={w} className="flex items-center gap-10 pr-10">
      <span className="font-display text-5xl font-black uppercase italic text-white sm:text-7xl">{w}</span>
      <span className="h-4 w-4 rotate-45 bg-blue-600" />
    </span>
  ));
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-white/10 bg-[#0D1015] py-8">
      <div className="marquee-track flex w-max">
        <div className="flex">{row}</div>
        <div className="flex" aria-hidden="true">{row}</div>
      </div>
    </div>
  );
};
